import { render, staticRenderFns } from "./institutionreport.vue?vue&type=template&id=5ab76fc3&"
import script from "./institutionreport.vue?vue&type=script&lang=js&"
export * from "./institutionreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports